import { render } from "./AlgorithmPage.vue?vue&type=template&id=33a2340b&scoped=true"
import script from "./AlgorithmPage.vue?vue&type=script&lang=js"
export * from "./AlgorithmPage.vue?vue&type=script&lang=js"

import "./AlgorithmPage.vue?vue&type=style&index=0&id=33a2340b&scoped=true&lang=css"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a2340b"]])

export default __exports__